import { schema } from "normalizr";

export const dashboardSchema = new schema.Entity("dashboards", {});

export const dashboardListSchema = [dashboardSchema];

